import fetchApi from '../utilities/fetch/httpService'
import apiUrls  from '../utilities/consts/apiUrls'

// last_name, mobile, email, job_title, cv_file

export const sendJobRequest = ({last_name, mobile, email, job_title, cv_file}) =>
  fetchApi({
    url: apiUrls.job_request,
    body: {last_name, mobile, email, job_title, cv_file},
    method: 'POST',
    hasFile: true
  })
